import { render } from "./CustomerStatistics.vue?vue&type=template&id=acbae788"
import script from "./CustomerStatistics.vue?vue&type=script&lang=js"
export * from "./CustomerStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__